import React from "react";
import CheckBox from "@components/checkBox";
import Wrapper from "./consentCheckbox.styles";
import { useFormikContext } from "formik";
import { useSetDefaultValue } from "@hooks";
import environmentSettings from "@src/constants/environmentSettings";
import getOppositeCompanyName from "@src/constants/getOppositeCompanyName";

const name = "referralConsent";

export default function ReferralConsentCheckbox({ ...props }) {
  const { companyName } = environmentSettings;

  const {
    handleChange,
    handleBlur,
    values,
    errors,
    touched,
  } = useFormikContext();
  useSetDefaultValue(name, false);

  return (
    <Wrapper>
      <label>
        <CheckBox
          name={name}
          checked={values[name]}
          onChange={handleChange}
          onBlur={handleBlur}
          errorMessage={touched[name] ? errors[name] : ""}
        >
          <ul>
            <strong>Being referred to another credit provider</strong> if{" "}
            {companyName} is unable to assist with your application. This may
            involve the sharing of your personal, sensitive, and credit
            information with related bodies corporate, including {getOppositeCompanyName}, who may offer you a similar or alternative
            financial product.
          </ul>
        </CheckBox>
      </label>
    </Wrapper>
  );
}
